/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled, { css } from "styled-components";
import { theme } from "@nordcloud/gnui";
import { isNotNil } from "~/tools";

type Props = {
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  variant?: "link" | "success";
  align?: string;
  border?: string;
};

export const InfoCard = styled.div<Props>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: 100%;
  background: ${theme.color.background.ui03};
  border: 1px solid ${theme.color.border.border01};
  box-sizing: border-box;
  padding: 1.5rem;
  border-radius: 0.25rem;
  flex: 1;
  margin: 0.75rem;
  justify-content: center;

  &:first-of-type {
    margin-left: 0;
  }

  &:last-of-type {
    margin-right: 0;
  }

  ${handleStylesFromProps};

  .title {
    font-weight: bold;
    margin-bottom: 0.5rem;
    font-size: 1.25rem;
  }
`;

function handleStylesFromProps({ onClick, variant, align }: Props) {
  const isClickable = isNotNil(onClick) || variant === "link";

  return css({
    ...(variant === "success" && {
      background: theme.color.background.success,
      color: theme.color.text.text04,
      "& .title": {
        color: theme.color.text.text04,
      },
    }),
    ...(align === "center" && {
      alignItems: "center",
    }),
    ...(isClickable && {
      cursor: "pointer",
      "&:hover": {
        backgroundColor: theme.color.background.ui04,
        textDecoration: "none",
      },
    }),
  });
}
